import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { useParams } from 'react-router-dom';
import PropertyListing from '../properties/PropertyListing';

export default function Service() {
  const { slug } = useParams();
  const [service, setService] = useState(null);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const loadService = async () => {
      try {
        setLoading(true);
        const res = await axios.get(`${process.env.REACT_APP_API_PATH}services/public`, {
          params: {
            serviceSlug: slug,
          },
        });
        if (res.status !== +process.env.REACT_APP_RECORD_NOT_FOUND) {
          const { error, data } = res.data;
          if (!error && typeof data === 'object') {
            setService(data);
          }
        }
      } catch (err) {
        console.error(err);
      } finally {
        setLoading(false);
      }
    };
    loadService();    
  }, [slug]);

  if (loading) {
    return (
      <div className="flex justify-center items-center min-h-screen">
        <div className="animate-spin h-12 w-12 border-4 border-blue-500 border-t-transparent rounded-full" />
      </div>
    );
  }

  if (!service) {
    return (
      <div className="text-center text-gray-500 py-20">
        <p>Service not found or failed to load.</p>
      </div>
    );
  }

  const { rootImagePath, defaultImage, name, fullDescription, shortDescription, properties = []} = service;

  return (
    <div className="min-h-screen bg-gray-50 py-12 px-4">
      <div className="max-w-4xl mx-auto bg-white rounded-3xl shadow-xl overflow-hidden">
        {/* Title Section */}
        <div className="text-center px-6 py-10 border-b">
          <h1 className="text-4xl font-bold text-gray-800 mb-2">{name}</h1>
          {shortDescription && (
            <p className="text-lg text-gray-600">{shortDescription}</p>
          )}
        </div>

        {/* Image Centered */}
        <div className="w-full flex justify-center py-6 px-4 text-center" >
          <img
            src={rootImagePath + defaultImage}
            alt={name}
            className="rounded-xl object-cover w-full max-w-xl shadow-md transition-transform duration-300 hover:scale-105"
            onError={(e) => (e.target.src = '/favicon.ico')}
          />
        </div>

        {/* Full Description */}
        <div className="px-6 pb-10">
          <div
            className="text-gray-700 text-lg leading-7 prose max-w-none"
            dangerouslySetInnerHTML={{ __html: fullDescription }}
          />
        </div>

        {
          properties.length > 0 && 
          <div className="px-6 pb-10">
            <PropertyListing propertyListing={properties} />
          </div>
        }

      </div>
    </div>
  );
}